class OverlayVideo {
    constructor() {
        this.body         = document.querySelector('body');
        this.openOverlay  = document.querySelectorAll('.js-open-video');
        this.overlay      = document.querySelector('.overlay-video');
        this.video        = this.overlay.querySelector('video');
        this.closeOverlay = document.getElementById('close-overlay');
        this.textBandeau  = document.getElementById('text-bandeau');

        for (let i = 0; i < this.openOverlay.length; i++) {
            this.openOverlay[i].addEventListener('click', () => this.open(this.openOverlay[i]));
        }

        this.close();
    }

    open(element) {
        this.overlay.classList.add('active');
        this.body.classList.add('overlay-is-active');
        this.video.src               = element.getAttribute('data-video');
        this.textBandeau.textContent = element.getAttribute('data-video-title');
    }

    close() {
        document.addEventListener('click', (e) => {
            if(e.target === this.overlay) {
                this.overlay.classList.remove('active');
                this.body.classList.remove('overlay-is-active');
                this.video.pause();
            }
        });
        
        this.closeOverlay.addEventListener('click', () => {
            this.overlay.classList.remove('active');
            this.body.classList.remove('overlay-is-active');
            this.video.pause();
        });
    }
}